import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=20e70902&scoped=true&"
import script from "./Tutorial.vue?vue&type=script&lang=js&"
export * from "./Tutorial.vue?vue&type=script&lang=js&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=20e70902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e70902",
  null
  
)

export default component.exports